// One spring-driven hover surface moves between menu links and the account / cart buttons.
(() => {
  const menu = document.querySelector("#site-menu");
  const list = menu?.querySelector(".menu-links");
  if (!list) return;
  const links = [...list.querySelectorAll(":scope > li > a, .menu-utils .menu-util")];
  const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)");
  const finePointer = matchMedia("(hover: hover) and (pointer: fine)");
  const position = [0, 0, 0, 0];
  const velocity = [0, 0, 0, 0];
  let target = [...position];
  let active = null;
  let frame = 0;
  let previousTime = 0;
  let initialized = false;

  list.classList.add("has-hover-pill");
  const paint = () => {
    ["x", "y", "w", "h"].forEach((key, i) => {
      list.style.setProperty(`--hover-${key}`, `${position[i]}px`);
    });
  };
  const tick = (time) => {
    const dt = Math.min((time - previousTime) / 1000 || 1 / 60, 1 / 30);
    previousTime = time;
    let moving = false;
    for (let i = 0; i < 4; i++) {
      velocity[i] += ((target[i] - position[i]) * 380 - velocity[i] * 30) * dt;
      position[i] += velocity[i] * dt;
      if (Math.abs(target[i] - position[i]) > .05 || Math.abs(velocity[i]) > .1) moving = true;
    }
    if (!moving) position.splice(0, 4, ...target);
    paint();
    frame = moving ? requestAnimationFrame(tick) : 0;
  };
  const follow = (link, event) => {
    if (menu.classList.contains("is-collapsed")) return;
    const box = link.getBoundingClientRect();
    const parent = list.getBoundingClientRect();
    const offsetX = event ? Math.max(-3, Math.min(3, (event.clientX - box.left - box.width / 2) * .1)) : 0;
    const offsetY = event ? Math.max(-2, Math.min(2, (event.clientY - box.top - box.height / 2) * .1)) : 0;
    target = [box.left - parent.left + offsetX, box.top - parent.top + offsetY, box.width, box.height];
    active = link;
    if (!initialized || reduceMotion.matches) {
      position.splice(0, 4, ...target);
      velocity.fill(0);
      initialized = true;
      paint();
    }
    list.classList.add("is-hovering");
    if (!frame && !reduceMotion.matches) {
      previousTime = performance.now();
      frame = requestAnimationFrame(tick);
    }
  };
  const hide = () => {
    list.classList.remove("is-hovering");
    cancelAnimationFrame(frame);
    frame = 0;
    active = null;
    initialized = false;
  };
  links.forEach((link) => {
    link.addEventListener("pointerenter", (event) => { if (finePointer.matches) follow(link, event); });
    link.addEventListener("pointermove", (event) => { if (finePointer.matches) follow(link, event); });
    link.addEventListener("focus", () => follow(link));
  });
  list.addEventListener("pointerleave", () => {
    const focused = links.find((link) => link === document.activeElement);
    if (focused) follow(focused); else hide();
  });
  list.addEventListener("focusout", (event) => { if (!links.includes(event.relatedTarget)) hide(); });
  new MutationObserver(() => { if (menu.classList.contains("is-collapsed")) hide(); }).observe(menu, {attributes: true, attributeFilter: ["class"]});
  new ResizeObserver(() => { if (active) follow(active); }).observe(list);
  reduceMotion.addEventListener("change", () => { hide(); });
})();
